import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AboutCTA() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#f8fafc] py-20 px-6 lg:px-12">
      <div className="bg-[#0A1628] rounded-3xl p-10 lg:p-16 flex flex-col lg:flex-row items-center justify-between gap-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#0A1628]/10 blur-3xl pointer-events-none" />
        <div className="relative z-10">
          <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-3">{t("aboutCtaTag")}</p>
          <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
            {t("aboutCtaTitle")}<br />{t("aboutCtaAccent")}
          </h2>
        </div>
        <div className="relative z-10 flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/services"
            className="bg-[#0A1628] text-white text-sm font-bold px-8 py-3.5 rounded-full hover:bg-[#0A1628] transition-all whitespace-nowrap text-center"
          >
            {t("aboutCtaExplore")}
          </Link>
          <Link
            to="/contact"
            className="border border-white/30 text-white text-sm font-semibold px-8 py-3.5 rounded-full hover:bg-white/10 transition-all whitespace-nowrap text-center"
          >
            {t("aboutCtaContact")}
          </Link>
        </div>
      </div>
    </section>
  );
}
